import { useRecoilValue } from 'recoil';
import { chatEventsSelector } from '@/state/session';
import { AnalyticsEvent, useAnalytics } from './useAnalytics';
export const useTrackMessageAnalytics = () => {
    const chatEvents = useRecoilValue(chatEventsSelector);
    const { trackEvent } = useAnalytics();
    const trackMessageClick = (event, payload) => {
        // check how many user messages exist before this event
        let count = 0;
        chatEvents.forEach((chatEvent) => {
            if (chatEvent.event_type === 'user_message') {
                count++;
            }
            if (chatEvent.event_id === event.event_id) {
                return;
            }
        });
        trackEvent(AnalyticsEvent.MessageClick, Object.assign(Object.assign({}, payload), { level: count }));
    };
    return { trackMessageClick };
};
